import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { MapPin } from "lucide-react";
import { toast } from "sonner";

export default function WorkLocationPanel() {
  const [users, setUsers] = useState([]);
  const [jur, setJur] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/onboarding/candidates").then((r) => setUsers(r.data)).catch(() => {}); api.get("/jurisdictions").then((r) => setJur(r.data)).catch(() => {}); }, []);
  const save = async (u, work_state, work_locals) => {
    try { await api.put(`/users/${u.id}/work-location`, { work_state: work_state === "none" ? null : work_state, work_locals }); setUsers((us) => us.map((x) => (x.id === u.id ? { ...x, work_state: work_state === "none" ? null : work_state, work_locals } : x))); toast.success(`Work location saved for ${u.name}`); }
    catch { toast.error("Could not save"); }
  };
  if (!jur) return null;
  return (
    <Card data-testid="work-location-panel" className="p-4 bg-white border-slate-200 mb-6">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 text-left">
        <MapPin className="w-4 h-4 text-[#C7761A]" /><span className="font-display font-bold text-[#0A2A5E]">Employee primary work locations</span>
        <span className="text-xs text-slate-500 ml-2">Pre-fills each person's default jurisdictional context (work location, not headquarters)</span><span className="ml-auto text-xs text-[#7C3F00] font-semibold">{open ? "Hide" : "Manage"}</span>
      </button>
      {open && (
        <div className="mt-3 divide-y divide-slate-100">
          {users.map((u) => {
            const st = jur.states.find((s) => s.code === u.work_state);
            return (
              <div key={u.id} data-testid={`wl-row-${u.id}`} className="py-2 flex flex-wrap items-center gap-3 text-sm">
                <div className="flex-1 min-w-[12rem]"><div className="font-medium text-slate-800">{u.name}</div><div className="text-xs text-slate-500">{u.email}</div></div>
                <Select value={u.work_state || "none"} onValueChange={(v) => save(u, v, [])}>
                  <SelectTrigger data-testid={`wl-state-${u.id}`} className="w-52 h-8 text-xs"><SelectValue placeholder="Work state" /></SelectTrigger>
                  <SelectContent className="max-h-72"><SelectItem value="none">Not set</SelectItem>{jur.states.map((s) => <SelectItem key={s.code} value={s.code}>{s.name}</SelectItem>)}</SelectContent>
                </Select>
                {st?.locals.map((l) => <label key={l.code} className="flex items-center gap-1.5 text-xs"><Checkbox data-testid={`wl-local-${u.id}-${l.code}`} checked={(u.work_locals || []).includes(l.code)} onCheckedChange={(v) => save(u, u.work_state, v ? [...(u.work_locals || []), l.code] : (u.work_locals || []).filter((c) => c !== l.code))} />{l.name}</label>)}
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
